<app-modal #modal>
    <ng-container modal-header>
        {{ 'admin.users.detailsModal.title' | translate }}
    </ng-container>

    <ng-container modal-body>
        <div class="user-details" *ngIf="selectedUser">
            <div class="user-summary">
                <div class="user-summary__line">
                    <strong class="user-summary__label">{{ 'admin.users.table.columns.fullMame' | translate }}:</strong>
                    <span class="user-summary__value">{{ selectedUser.fullName || selectedUser.username }}</span>
                </div>
                <div class="user-summary__line">
                    <strong class="user-summary__label">{{ 'admin.users.table.columns.badge' | translate }}:</strong>
                    <span class="user-summary__value">{{ selectedUser.boschId || ('generic.notAvailable' | translate) }}</span>
                </div>
                <div class="user-summary__line">
                    <strong class="user-summary__label">{{ 'admin.users.table.columns.email' | translate }}:</strong>
                    <span class="user-summary__value">{{ selectedUser.email || '-' }}</span>
                </div>
                <div class="user-summary__line">
                    <strong class="user-summary__label">{{ 'admin.users.table.columns.status' | translate }}:</strong>
                    <ng-container *ngIf="canManageUsers; else statusDisplay">
                        <div class="user-summary__value">
                            <app-input-switch [(ngModel)]="draftIsActive"
                                              onLabel="{{'admin.users.table.rows.updateStatus.onLabel' | translate}}"
                                              offLabel="{{'admin.users.table.rows.updateStatus.offLabel' | translate}}">
                            </app-input-switch>
                        </div>
                    </ng-container>
                    <ng-template #statusDisplay>
                        <span class="user-summary__value">{{ (selectedUser.isActive ? 'admin.users.table.rows.active' : 'admin.users.table.rows.disabled') | translate }}</span>
                    </ng-template>
                </div>
                <div class="user-summary__line">
                    <strong class="user-summary__label">{{ 'admin.users.table.columns.userBusinessType' | translate }}:</strong>
                    <ng-container *ngIf="canManageUsers; else businessTypeDisplay">
                        <div class="user-summary__value">
                            <app-dropdown [(ngModel)]="draftUserBusinessType"
                                          [items]="userBusinessTypes"
                                          valueField="value"
                                          displayField="name"
                                          [emptyText]="'generic.dropdown.emptyMessage' | translate">
                            </app-dropdown>
                        </div>
                    </ng-container>
                    <ng-template #businessTypeDisplay>
                        <span class="user-summary__value">{{ businessTypeLabel(selectedUser) | translate }}</span>
                    </ng-template>
                </div>
            </div>

            <div class="roles-section">
                <strong class="roles-section__title">{{ 'admin.users.detailsModal.roles' | translate }}</strong>
                <div class="roles-section__content">
                    <div class="roles-section__empty" *ngIf="!selectedUser.roles?.length">
                        {{ 'admin.users.detailsModal.noRoles' | translate }}
                    </div>
                    <div class="roles-list" *ngIf="selectedUser.roles?.length">
                        <span class="role-chip" *ngFor="let role of selectedUser.roles">{{ role.name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container modal-footer>
        <div class="modal-actions">
            <app-button type="simple" (clicked)="close()">
                {{ 'generic.buttons.close' | translate }}
            </app-button>

            <div class="modal-actions__right" *ngIf="canManageUsers && selectedUser">
                <app-button type="primary"
                            [disabled]="!hasChanges"
                            (clicked)="onUpdateUser()">
                    {{ 'generic.buttons.update' | translate }}
                </app-button>
            </div>

            <div class="modal-actions__danger" *ngIf="canManageUsers && selectedUser && !selectedUser.isADUser">
                <app-button type="danger" (clicked)="onResetUser()">
                    {{ 'admin.users.reset.button' | translate }}
                </app-button>
                <app-button type="danger" (clicked)="onDeleteUser()">
                    {{ 'admin.users.delete.button' | translate }}
                </app-button>
            </div>
        </div>
    </ng-container>
</app-modal>
